export const upgradeVersion = '6.0.0';
export const versionPrefixes = ['~', '^', ''];
